import React from "react";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import NewFooter from "../components/footers/NewFooter";
import {ReactComponent as SvgDecoratorBlob1} from "images/svg-decorator-blob-9.svg";
import {ContentWithPaddingLg} from "components/misc/Layouts";
import LogoImage from "images/mai-logo.png";

const HeaderContainer = tw.div`w-full flex flex-col items-center md:px-8 px-3 relative z-20`;

const PrimaryBackgroundContainer = tw.div`py-20 lg:py-24 bg-secondary-600 rounded-lg relative`;
const Row = tw.div`px-8 mx-auto flex items-center relative z-10 flex-col lg:flex-row text-center`;

const ColumnContainer = tw.div`lg:w-full mx-auto`;
const TextContainer = tw(ColumnContainer)``;
const Heading = tw.h2`text-3xl md:text-4xl font-bold text-white mb-6`;
const Description = tw.p`mb-6 max-w-lg mx-auto text-center text-sm md:text-base lg:text-lg font-normal leading-relaxed text-white`;

const DecoratorBlobContainer = tw.div`absolute inset-0 overflow-hidden rounded-lg`;
const DecoratorBlob1 = tw(SvgDecoratorBlob1)`absolute bottom-0 left-0 w-80 h-80 transform -translate-x-20 translate-y-32 text-secondary-700 opacity-50`;
const DecoratorBlob2 = tw(SvgDecoratorBlob1)`absolute top-0 right-0 w-80 h-80 transform translate-x-20 -translate-y-64 text-secondary-700 opacity-50`;


const LogoImg = tw.img`w-24 mx-auto mb-5`;

const Container = tw.div`relative`;

export default class extends React.Component {
    render() {
        return (
            <AnimationRevealPage isLanding>
                <Container>
                    <HeaderContainer>
                        <ContentWithPaddingLg>
                            <PrimaryBackgroundContainer>
                                <Row>
                                    <TextContainer>
                                        <LogoImg alt="MAI Motion" src={LogoImage}/>
                                        <Heading>Congrats on signing up to your FREE scan</Heading>
                                        <Description>
                                            Your login details and next steps
                                            have been set to your email.
                                        </Description>
                                        <Description style={{marginTop: '10px', fontWeight: '600', fontStyle: "italic"}}>
                                            Please check your spam/junk folder just in case
                                        </Description>
                                    </TextContainer>
                                </Row>
                                <DecoratorBlobContainer>
                                    <DecoratorBlob1/>
                                    <DecoratorBlob2/>
                                </DecoratorBlobContainer>
                            </PrimaryBackgroundContainer>
                        </ContentWithPaddingLg>
                    </HeaderContainer>
                </Container>
                <NewFooter/>
            </AnimationRevealPage>
        );
    }
};
